// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611041935/js/" + chunkId + "." + {"44":"254dbdba","225":"bc56cc5b","481":"2eef0a0a","486":"b377b9a0","770":"daf6f145"}[chunkId] + ".0.18894993617890388.chunk.js";
};